<template>
  <div id="app" ref="appbg">
    <!-- <img src="./assets/favicon.ico"> -->
    <div id="body">
      <!-- ref="vantaRef" -->
      <div id="header" ref="vantaRef">
        <div class="a_head">
          <span class="a" @click="to('https://www.guet.edu.cn')"
            >桂林电子科技大学</span
          >
          <span
            class="a"
            @click="to('https://www.guet.edu.cn/dept10/index.psp')"
            >材料与科学工程学院</span
          >
        </div>
        <div class="name">
          <img class="logo" :src="teamDetail.image" alt="" />
          <!-- <img :src="logotext503" alt="" /> -->
           <div class="GName">
              <div class="h1">{{ teamDetail.name }}</div>
              <div class="h2">{{ teamDetail.englishName }}</div>
           </div>
        </div>
        <div class="menu">
          <el-menu
            :default-active="activeIndex"
            mode="horizontal"
            @select="handleSelect"
            background-color="rgba(0,0,0,0)"
            text-color="#fff"
            active-text-color="#fff"
          >
            <el-menu-item
              v-for="item in page"
              :key="item.name"
              :index="item.name"
              v-show="!item.hidden"
            >
              <div class="twoLineText">{{ item.cn }}<br />{{ item.name }}</div>
            </el-menu-item>
            <!-- <el-submenu index="2">
              <template slot="title">我的工作台</template>
              <el-menu-item index="2-1">选项1</el-menu-item>
              <el-menu-item index="2-2">选项2</el-menu-item>
              <el-menu-item index="2-3">选项3</el-menu-item>
              <el-submenu index="2-4">
                <template slot="title">选项4</template>
                <el-menu-item index="2-4-1">选项1</el-menu-item>
                <el-menu-item index="2-4-2">选项2</el-menu-item>
                <el-menu-item index="2-4-3">选项3</el-menu-item>
              </el-submenu>
            </el-submenu> -->
            <!-- <el-menu-item index="3" disabled></el-menu-item> -->
            <!-- <el-menu-item index="4"
              ><a href="https://www.ele.me" target="_blank"
                >订单管理</a
              ></el-menu-item
            > -->
          </el-menu>
        </div>
      </div>

      <div id="main" >
        <router-view/>
      </div>
      <div id="footer">
        <div class="copyright">
          有机光电材料与器件团队 ©版权所有
          <div class="en">
            Copyright© Jian Zhang's Group , All Rights Reserved
          </div>
          <div class="en">
            <a style="color: #fff;" href="http://beian.miit.gov.cn/">黑ICP备2025036339号</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import logo from '@/images/logo.png'
import logotext503 from '@/images/logo_text_503.png'
import * as THREE from 'three'
// import waves from 'vanta/src/vanta.globe'
import bg from 'vanta/src/vanta.waves'
import {getTeamDetail} from '@/api/api'
export default {
  name: 'App',
  mounted () {
    this.initVanta()
    this.initScrollAnimation()
  },
  beforeDestroy () {
    if (this.vantaEffect) {
      this.vantaEffect.destroy()
    }
    if (this.scrollObserver) {
      this.scrollObserver.disconnect()
    }
    window.removeEventListener('scroll', this.handleScroll)
  },
  watch: {
    $route (to, from) {
      this.activeIndex = to.name
      if (this.scrollObserver) {
        this.scrollObserver.disconnect()
      }
      this.$nextTick(() => {
        this.initScrollAnimation()
      })
    }
  },
  data () {
    return {
      logo,
      logotext503,
      activeIndex: 'Home',
      page: [],
      teamDetail: {},
      scrollObserver: null
    }
  },
  created () {
    this.page = this.$router.options.routes
    this.activeIndex = this.$router.history.current.name
    this.getTeamDetail()
  },
  methods: {
    initVanta () {
      this.vantaEffect = bg({
        el: this.$refs.vantaRef,
        THREE: THREE,
        color: 0x1A3D3D,
        color2: 0x1A3D3D,
        backgroundColor: 0x1A3D3D,
        points: 8.00,
        spacing: 20.00,
        maxDistance: 24.00
      })
    },
    initScrollAnimation () {
      this.scrollObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible')
          }
        })
      }, { threshold: 0.1 })

      document.querySelectorAll('.scroll-animate').forEach(el => {
        this.scrollObserver.observe(el)
      })
    },
    getTeamDetail () {
      const data = localStorage.getItem('teamDetail')
      if (data) {
        this.teamDetail = JSON.parse(data)
      }
      getTeamDetail().then(res => {
        if (res.code === 200) {
          this.teamDetail = res.data
          localStorage.setItem('teamDetail', JSON.stringify(res.data))
        }
      })
    },
    to (http) {
      window.location.href = http
    },
    handleSelect (key, keyPath) {
      this.activeIndex = key
      this.page.filter((item) => {
        return item.name === key
      })
      let topath = this.page.filter((item) => {
        return item.name === key
      })
      if (topath[0]) {
        this.$router.push(topath[0].path)
      }
    }
  }
}
</script>

<style>
@import './styles/animations.css';

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  color: #2c3e50;
  background: #2F4F4F;
  height: 100%;
  min-width: 1160px;
}

#body {
  width: 1160px;
  background: rgba(255, 0, 0, 0.1);
  overflow: hidden;
  margin: 0 auto;
  box-sizing: border-box;
}

#header {
  height: 240px;
  width: 1160px;
}

/* 路由切换动画 */
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

.slide-up-enter-active, .slide-up-leave-active {
  transition: all 0.4s ease;
}

.slide-up-enter, .slide-up-leave-to {
  opacity: 0;
  transform: translateY(20px);
}
</style>

<style scoped>
.a_head {
  padding: 10px 20px;
  background: linear-gradient(
    to right,
    rgba(0, 0, 0, 0.3),
    rgba(0, 0, 0, 0)
  );
  color: #fff;
  animation: fadeInDown 0.6s ease-out;
}

.a {
  transition: all 0.3s ease;
  font-size: 14px;
  position: relative;
}

.a + .a {
  padding-left: 40px;
}

.a:hover {
  cursor: pointer;
  color: #D4AF37;
  transform: translateX(5px);
}

.name {
  width: 100%;
  height: 140px;
  display: flex;
  align-items: center;
  padding: 0 20px;
  box-sizing: border-box;
  animation: fadeIn 0.8s ease-out 0.2s both;
}

.menu {
  background: linear-gradient(to right, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.3));
  animation: fadeInUp 0.6s ease-out 0.4s both;
}

.el-menu-item {
  transition: all 0.3s ease;
  position: relative;
}

.el-menu-item::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  width: 0;
  height: 2px;
  background: #D4AF37;
  transition: all 0.3s ease;
  transform: translateX(-50%);
}

.el-menu-item:hover::after {
  width: 80%;
}

.el-menu-item:hover {
  background-color: rgba(0, 0, 0, 0.3) !important;
  transform: translateY(-2px);
}

.twoLineText {
  line-height: 20px !important;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.logo {
  height: 120px;
}

#main {
  background: #fff;
  width: 1160px;
  min-height: calc(100vh - 355px);
  overflow: hidden;
  padding: 20px;
  box-sizing: border-box;
  animation: fadeIn 0.5s ease-out;
}

#footer {
  background: #1A3D3D;
  color: #fff;
  font-size: 14px;
  padding: 20px;
  position: relative;
  overflow: hidden;
}

#footer::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 2px;
  background: linear-gradient(90deg, transparent, #D4AF37, transparent);
  animation: shimmer 3s linear infinite;
}

.copyright {
  position: relative;
  z-index: 1;
}

.en {
  margin-top: 10px;
  transition: all 0.3s ease;
}

.en:hover {
  color: #D4AF37;
}

.h1 {
  font-size: 40px;
  color: #fff;
  font-weight: 600;
  font-family: 'Times New Roman';
  letter-spacing: 5px;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
  animation: fadeInLeft 0.8s ease-out 0.3s both;
}

.h2 {
  color: #D4AF37;
  font-size: 13px;
  letter-spacing: 2px;
  animation: fadeInLeft 0.8s ease-out 0.5s both;
}

.GName {
  margin-left: 20px;
}

.is-active {
  border-bottom-color: #D4AF37 !important;
}

/* 链接动画 */
#footer a {
  position: relative;
  text-decoration: none;
  transition: color 0.3s ease;
}

#footer a::after {
  content: '';
  position: absolute;
  bottom: -2px;
  left: 0;
  width: 0;
  height: 1px;
  background: #D4AF37;
  transition: width 0.3s ease;
}

#footer a:hover::after {
  width: 100%;
}

#footer a:hover {
  color: #D4AF37 !important;
}
</style>
